import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Ad610CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.AD610];

	public override getDeviceNameMaxLength(_model: DeviceModel): number | undefined {
		return 8;
	}

	public override showPatentInfo(): boolean {
		return true;
	}
}
